import CurrentEvent from '@/components/currentEvent/CurrentEvent'
import Divider from '@/components/divider/Divider'
import Image from '@/components/image/Image'
import Grid from '@mui/material/Grid2'
import React from 'react'

const UpcommingEvents: React.FC = () => {
  return (
    <Grid
      container
      direction="row"
      rowSpacing={4}
      justifyContent="center"
      alignItems="flex-start"
      textAlign="center"
      pb={10} // Added padding-bottom to create space before the footer
    >
      {/* Top Section */}
      <CurrentEvent />

      <Divider size={{ xs: 11, md: 10 }} />

      <Grid size={12}>
        <h2>Återkommande Events</h2>
      </Grid>

      {/* Two-Column Grid Section */}
      <Grid
        container
        size={{ xs: 12, md: 10 }}
        spacing={6}
        justifyContent="center"
        alignItems="flex-start"
      >
        {/* 1. Sankt Georgsdagen */}
        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Sankt Georgsdagen</h3>
          <p style={{ textAlign: 'left' }}>
            Den 23 april firar vi Sankt Georgsdagen med Sjöscouterna, antingen
            vid Scoutstugan eller i Näsviken.
          </p>
          <Image src="/images/events/st-george.jpg" alt="Saint George" />
        </Grid>

        {/* 2. Valborgsmässoafton */}
        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Valborgsmässoafton</h3>
          <p style={{ textAlign: 'left' }}>
            Den 30 april spelar vi i Snäckan, Rosengården, och firar in våren
            med hela scoutkåren - en tradition sedan 1924.
          </p>
          <Image src="/images/events/valborg.jpg" alt="Valborg" />
        </Grid>

        {/* 3. Kastellets dag */}
        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Kastellets dag</h3>
          <p style={{ textAlign: 'left' }}>
            Varje år på Kastellets dag, början av juni, spelar vi på Kastellet.
            Samtidigt invigs nya medlemmar i Castellanerna, Lions säljer
            våfflor, Teatersmedjan håller öppen repetition och syrenerna står i
            blom.
          </p>
          <Image src="/images/events/kastellets-dag.jpg" alt="Kastellets dag" />
        </Grid>

        {/* 4. Östersjöfestivalen */}
        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Östersjöfestivalen</h3>
          <p style={{ textAlign: 'left' }}>
            Vi klär ut oss, marscherar i den årliga festivalparaden och håller
            konserter i staden.
          </p>
          <Image
            src="/images/events/ostersjofestivalen.jpg"
            alt="Östersjöfestivalen"
          />
        </Grid>

        {/* 5. Kulturnatten */}
        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Kulturnatten</h3>
          <p style={{ textAlign: 'left' }}>
            I oktober deltar vi på Kulturnatten, där vi spelar vid Mieån en
            stund innan Scouternas årliga Ljusregatta.
          </p>
          <Image
            src="/images/events/kulturnatten-2024.jpg"
            alt="Kulturnatten"
          />
        </Grid>

        {/* 6. Tomteparaden */}
        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Tomteparaden första advent</h3>
          <p style={{ textAlign: 'left' }}>
            Vi marscherar i tomtekläder genom stan under julskyltningen och
            avslutar på torget, där vi bjuder in stora som små till dans kring
            granen.
          </p>
          <Image
            src="/images/events/santa-claus-parade.jpg"
            alt="Tomteparaden"
          />
        </Grid>

        {/* 7. Lübeck */}
        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Julmarknaden i Lübeck andra advent</h3>
          <p style={{ textAlign: 'left' }}>
            Varje år beger vi oss till Lübeck, julmarknadernas huvudstad, och
            sprider musik och glädje på gatorna. Efteråt belönar vi oss själva
            med julgodis, skratt och skönt häng - och alla slantar vi spelar in
            går oavkortat till ett besök på stadens indiska restaurang.
          </p>
          <Image src="/images/events/lübeck-2022.jpg" alt="Lübeck" />
        </Grid>

        {/* 8. Julafton */}
        <Grid size={{ xs: 11, md: 5 }}>
          <h3>Julaftonsdans på torget</h3>
          <p style={{ textAlign: 'left' }}>
            Vi sprider julglädje till dem som annars firar ensamma.
          </p>
          <Image src="/images/events/christmas-eve.jpg" alt="Julafton" />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default UpcommingEvents
